var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoRejectSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20ZM13.3839 11.6161C12.8957 11.128 12.1043 11.128 11.6161 11.6161C11.128 12.1043 11.128 12.8957 11.6161 13.3839L18.2322 20L11.6161 26.6161C11.128 27.1043 11.128 27.8957 11.6161 28.3839C12.1043 28.872 12.8957 28.872 13.3839 28.3839L20 21.7678L26.6161 28.3839C27.1043 28.872 27.8957 28.872 28.3839 28.3839C28.872 27.8957 28.872 27.1043 28.3839 26.6161L21.7678 20L28.3839 13.3839C28.872 12.8957 28.872 12.1043 28.3839 11.6161C27.8957 11.128 27.1043 11.128 26.6161 11.6161L20 18.2322L13.3839 11.6161Z",
    fill: "#CC334C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRejectSolid);
export default __webpack_public_path__ + "static/media/ico-reject_solid.f2e76317645677c8b927d86fca817683.svg";
export { ForwardRef as ReactComponent };